import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-asociar-traducciones',
    templateUrl: './asociar-traducciones.component.html'
})
export class AsociarTraduccionesComponent implements OnInit {
    public new = false;
    public traducciones;

    @Input() objeto;
    @Input() nombreComponente;
    @Output() pushMessage = new EventEmitter<string>();
    @Output() refresh = new EventEmitter<boolean>();

    constructor(){}

    ngOnInit(){
        for (let property in Object.keys(this.objeto)) {
            if ((Object.keys(this.objeto)[property]).includes('idiomas')) {
                this.traducciones = this.objeto[Object.keys(this.objeto)[property]];
            }
        }
    }

    public toRefresh(value) {
        this.refresh.emit(value);
    }
}